import { cva } from 'class-variance-authority';

export const phoneInputStyles = cva([
  'font-inter font-normal text-base leading-[150%] border-none outline-none shadow-none rounded-none w-full font-normal bg-transparent placeholder:text-neutral-700 pl-0',
]);

export const phoneInputWrapperStyles = cva(
  [
    'relative text-base font-normal leading-[150%] border w-full flex items-center rounded-[6px] focus-within:border-blue-300',
  ],
  {
    variants: {
      error: {
        true: ['border-red-500'],
        false: ['border-grey-400'],
      },
      disabled: {
        true: ['cursor-not-allowed bg-grey-200 border-grey-400 text-neutral-700'],
        false: ['bg-white text-grey-700 cursor-auto'],
      },
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
);
